module.exports = {
          srcSet: __webpack_public_path__ + "f15c22db6ab0d43f80689a71385d30be-196.png"+" 196w",
          images:[ {path: __webpack_public_path__ + "f15c22db6ab0d43f80689a71385d30be-196.png",width: 196,height: 142}],
          src: __webpack_public_path__ + "f15c22db6ab0d43f80689a71385d30be-196.png",
          toString:function(){return __webpack_public_path__ + "f15c22db6ab0d43f80689a71385d30be-196.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAHCAYAAAAxrNxjAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAeElEQVR4nFXOUQ4CMQgEUIw3HdZvj+evg+fxBruMoSlNbUKa0NcB0/swES8RT4Wbwu8iqmdJ2DoiXOESUfUonBuuavhRQAq/drwnDyziW4lJnPMuXFP+8IIiMomr10ji2PEcPR47ceCZ3GvcCmLsFn5W6vy0khv/AIKCsZsgEyOVAAAAAElFTkSuQmCC",
          width: 196,
          height: 142
        }